export default __webpack_public_path__ + "static/Banner_Colecta_1200x900-959294693eb5169a5cf74e43937eea56.jpg";